export const getDerasarPersonPhone = (person = {}) => person.phone || person.createdByMember?.phone || '';

export const getDerasarPersonEmail = (person = {}) => person.email || person.createdByMember?.auth?.email || '';

export const toDerasarPersonOption = (person = {}, extras = {}) => ({
  ...person,
  id: person.id,
  name: person.name,
  phone: getDerasarPersonPhone(person),
  email: getDerasarPersonEmail(person),
  ownerName: person.createdByMember?.name || '',
  createdByMemberId: person.createdByMemberId,
  ...extras,
});

export const toDerasarPersonOptions = (people = [], extras = {}) => (
  Array.isArray(people) ? people.map((person) => toDerasarPersonOption(person, extras)) : []
);
